// extracted by mini-css-extract-plugin
export var adaptiveBlock = "singleCard-module--adaptiveBlock--WibWd";
export var btnGroup = "singleCard-module--btnGroup--y8BfT";
export var btnPrimary = "singleCard-module--btnPrimary--c6ssj";
export var btnSecondary = "singleCard-module--btnSecondary--dMnN4";
export var card = "singleCard-module--card--oIGEE";
export var description = "singleCard-module--description--eFIMi";
export var hidden = "singleCard-module--hidden--Cgv54";
export var img = "singleCard-module--img--KoHii";
export var textBlock = "singleCard-module--textBlock--oqA+N";
export var title = "singleCard-module--title--Wcm3q";
export var zaimy = "singleCard-module--zaimy--Yrqc9";